/**
 * Formats a price value according to the given rounding and display rules:
 * - Round to 5 effective decimals (5 digits after decimal ignoring leading zeros)
 * - Display a minimum of 2 decimals (padded with zeros if necessary)
 * - Trailing zeros beyond the minimum 2 decimals are removed
 * 
 * @param {number} price - The price value to format
 * @returns {{ roundedPrice: string, displayedPrice: string }} - rounded and displayed price strings
 */
function formatPriceForAsset(price) {
    const numericPrice = Number(price);

    if (price == null || !Number.isFinite(numericPrice)) {
      return {
        fractionalCount: 2,
        displayedPrice: NaN,
      };
    }
      
    // Extract decimal part and find first non-zero digit index after decimal
    let numStr = numericPrice?.toFixed(16); // more precision to ensure rounding accuracy
    const decimalPart = numStr?.split('.')[1] || '';
    const firstNonZeroIndex = decimalPart?.search(/[1-9]/);
  
    // If no non-zero decimals, round to 2 decimals minimum directly
    if (firstNonZeroIndex === -1) {
      // Round to 2 decimals minimum
      const rounded = numericPrice?.toFixed(2);
      return {
        fractionalCount: 2,
        displayedPrice: +rounded
      };
    }
  
    // Number of decimal places to round to = firstNonZeroIndex + 5 (5 effective decimals)
    const digitsToRound = firstNonZeroIndex + 5;
  
    // Round the price to the required decimal place
    const factor = Math.pow(10, digitsToRound);
    const roundedNum = Math.round(numericPrice * factor) / factor;
  
    // Convert to string with fixed digitsToRound decimal places
    let roundedPriceStr = roundedNum?.toFixed(digitsToRound);
  
    // Now for the display price:
    // Remove trailing zeros but keep at least 2 decimals minimum
    let [intPart, fracPart=''] = roundedPriceStr?.split('.');
  
    // Remove trailing zeros
    fracPart = fracPart.replace(/0+$/, '');
  
    // Ensure minimum 2 decimals
    if (fracPart.length < 2) {
      fracPart = fracPart.padEnd(2, '0');
    }
  
    const displayedPriceStr = fracPart.length === 0 ? intPart + '.00' : intPart + '.' + fracPart;
  
    // return displayedPriceStr;
    return {
      fractionalCount: fracPart.length,
      displayedPrice: +displayedPriceStr
    };
    
  }
  
  export default formatPriceForAsset;